import {
    KindLogo,
    PerrigoLogo,
    ConstellationLogo,
    ConstellationSecondaryLogo,
    TruFruLogo,
    CooperLogo,
    DemoLogo,
    GPLogo,
    NaturesBakeryLogo,
    NomadFoodLogo,
    perrigoSpainLogo,
    perrigoBelgiumLogo,
    sauerBrandsLogo,
    HormelFoodsLogo,
    HormelFoodsSecondaryLogo,
    DanoneLogo,
} from 'assets/images';

const tenantLogoMapping: Record<string, string> = {
    kind: KindLogo,
    perrigo: PerrigoLogo,
    constellation: ConstellationLogo,
    truFru: TruFruLogo,
    cooper: CooperLogo,
    demo: DemoLogo,
    gp: GPLogo,
    naturesBakery: NaturesBakeryLogo,
    nomadFoods: NomadFoodLogo,
    perrigoSpain: perrigoSpainLogo,
    perrigoBelgium: perrigoBelgiumLogo,
    sauerBrands: sauerBrandsLogo,
    hormelFoods: HormelFoodsLogo,
    danone: DanoneLogo,
};

const secondaryTenantLogoMapping: Record<string, string> = {
    constellation: ConstellationSecondaryLogo,
    hormelFoods: HormelFoodsSecondaryLogo,
};

export const DEFAULT_TENANT_LOGO = DemoLogo;

export const getTenantLogo = (tenantId: string = ''): string => {
    return tenantLogoMapping[tenantId] || DEFAULT_TENANT_LOGO;
};

export const getSecondaryTenantLogo = (tenantId: string = ''): string | undefined => {
    return secondaryTenantLogoMapping[tenantId];
};
